export const nombreEstadoPrestamo = {
  0: 'Enviado',
  1: 'Reuniendo',
  2: 'Rechazado',
  3: 'Pagando',
  4: 'Pagado',
  5: 'Reunido',
  6: 'Oferta del préstamo en la espera de pago',
  7: 'El tiempo se acabo',
  8: 'Atrasado',
  9: 'Alguacil',
  10: 'Corte',
  11: 'Recuperación previa al juicio'
};
export const nombreEstadoPago = {
  0: 'Pendiente',
  1: 'Pagado',
  2: 'Pago próximo',
  3: 'Atrasado*',
  4: 'Atrasado**',
  5: 'Pago Actual',
  6: 'Ultimo Pago'
};
export const nombreGeneros = {
  H: 'Masculino',
  M: 'Femenino'
};
